import { useMemo } from 'react'

import type { OrganizationDto } from '../api/types'

export type BuyerEntitlements = {
  plan: string
  planDisplayName: string
  periodEnd: string | null
  marketPriceIntelligenceEnabled: boolean
  isStartPlan: boolean
  isPremium: boolean
}

export const entitlementsFromOrg = (organization: OrganizationDto | null): BuyerEntitlements => {
  const plan = organization?.plan ?? 'start'
  const isPremium = plan === 'premium'
  return {
    plan,
    planDisplayName: organization?.plan_display_name ?? (isPremium ? 'Premium' : 'Старт'),
    periodEnd: null,
    marketPriceIntelligenceEnabled: organization?.market_price_intelligence_enabled ?? isPremium,
    isStartPlan: plan === 'start',
    isPremium,
  }
}

export const useEntitlements = (organization: OrganizationDto | null): BuyerEntitlements =>
  useMemo(() => entitlementsFromOrg(organization), [organization])
